import styles from '@ui/components/Select/Select.module.scss';
import FontAwesomeProIcon from '@ui/components/FontAwesomeProIcon/FontAwesomeProIcon';
import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const SelectItemIcon = ({ isImage = false, src }) =>
  isImage ? (
    <img
      alt=""
      aria-hidden
      className={styles.selectItemIcon}
      role="presentation"
      src={src}
    />
  ) : (
    <FontAwesomeProIcon
      aria-hidden
      className={classNames(styles.selectItemIcon, styles.ico)}
      icon={src}
      role="presentation"
    />
  );

SelectItemIcon.propTypes = {
  isImage: PropTypes.bool,
  src: PropTypes.string.isRequired,
};

export default SelectItemIcon;
